module.exports = __webpack_public_path__ + "img/banner-news.f0899967.jpg";